module.exports = __webpack_public_path__ + "img/img-part-8-premiumcoupon.2173a75b.png";